import { useNavigate } from 'react-router-dom';
import type { DerivedStep } from './deriveGuide';
import TerminalEnvPanel from './TerminalEnvPanel';

type Props = {
  step: DerivedStep;
  environmentId: string;
  levelLocked: boolean;
  onSkip: (code: string) => void;
};

const WidgetStepRow = ({ step, environmentId, levelLocked, onSkip }: Props) => {
  const navigate = useNavigate();
  const isComplete = step.state === 'COMPLETE';
  const isSkipped = step.state === 'SKIPPED';
  const isResolved = isComplete || isSkipped;
  const isLocked = levelLocked || step.state === 'LOCKED';
  const isActive = !isLocked && step.state === 'AVAILABLE';
  const canNavigate = isActive && !!step.route;
  const showSkip = isActive && step.skippable;

  const circleClass = isResolved
    ? 'border-success text-success'
    : isLocked
      ? 'text-gray-400'
      : isActive
        ? 'border-primary text-primary'
        : 'text-gray-400';

  const handleRowClick = () => {
    if (canNavigate && step.route) navigate(step.route);
  };

  return (
    <div>
      <div
        className={`d-flex align-items-center gap-3 px-2 py-2 rounded ${
          isActive ? 'bg-light' : ''
        } ${canNavigate ? 'cursor-pointer' : ''}`}
        onClick={handleRowClick}
      >
        <span
          className={`d-flex align-items-center justify-content-center rounded-circle border border-2 ${circleClass}`}
          style={{ width: 18, height: 18, flex: '0 0 18px', fontSize: 9 }}
        >
          {isComplete ? '✓' : isSkipped ? '–' : isLocked ? '🔒' : isActive ? '●' : ''}
        </span>
        <span className={`fs-7 ${isResolved ? 'text-gray-500 text-decoration-line-through' : 'text-gray-800'}`}>
          {step.title}
        </span>
        {showSkip ? (
          <button
            type="button"
            className="btn btn-link btn-sm text-gray-500 ms-auto p-0 fs-8"
            onClick={(e) => {
              e.stopPropagation();
              onSkip(step.code);
            }}
          >
            Pular
          </button>
        ) : null}
      </div>

      {!!step.detail && <div className={`fs-8 ms-9 ${isLocked ? 'text-warning' : 'text-gray-500'}`}>{step.detail}</div>}

      {isActive && step.description ? <div className="fs-8 ms-9 text-gray-500">{step.description}</div> : null}

      {isActive && step.showEnvPanel ? (
        <div className="ms-9 me-2">
          <TerminalEnvPanel environmentId={environmentId} />
        </div>
      ) : null}
    </div>
  );
};

export default WidgetStepRow;
